<template>
  <article class="fb-ad">
    <header class="fb-ad__header">
      <div
        class="fb-ad__profile-img"
        :style="{ backgroundImage: `url(${page.picture.data.url})` }"
      ></div>
      <div>
        <h4 class="fb-ad__profile-name" v-text="page.name" />
        <div class="fb-ad__time-location">
          <span>Sponsored · </span><Globe />
        </div>
      </div>
      <div class="fb-ad__more">
        <More />
      </div>
    </header>
    <div class="fb-ad__post">
      <div v-for="(messageLine, index) in messageLines" :key="index">
        <span>{{ messageLine }}</span>
        <br v-if="index + 1 != messageLines.length" />
      </div>
    </div>
    <main class="fb-ad__main">
      <div class="fb-ad__link-web">
        <div
          class="fb-ad__link-image"
          :style="{ backgroundImage: `url(${model.media.url})` }"
        />
        <div class="fb-ad__link-body">
          <div>
            <div class="fb-ad__link-website" v-text="link" />
            <div class="fb-ad__link-title" v-text="headline" />
            <div
              class="fb-ad__link-subtitle"
              v-text="model.creative.objectStorySpec.description"
            />
          </div>
          <div>
            <a class="fb-ad__cta" v-text="callToAction.name" />
          </div>
        </div>
      </div>
    </main>
    <footer class="fb-ad__actions">
      <button class="fb-ad__action">
        <Like />
        To se mi líbí
      </button>
      <button class="fb-ad__action">
        <Comment />
        Okomentovat
      </button>
      <button class="fb-ad__action">
        <Share />
        Sdílet
      </button>
    </footer>
  </article>
</template>

<script>
import { call, get } from "vuex-pathify"

import * as icons from "@/components/icon/facebook-ad"

export default {
  shadow: true,
  components: {
    ...icons,
  },
  props: {
    storeNamespace: {
      type: String,
      required: true,
    },
  },
  computed: {
    callToAction() {
      if (this.model.creative.callToActionType) {
        return this.findAdsCallToActionType(
          this.model.creative.callToActionType
        )
      } else {
        return {
          key: "LEARN_MORE",
          name: "Další informace",
        }
      }
    },
    messageLines() {
      return this.model.creative.objectStorySpec.message.split("\n")
    },
    headline() {
      return this.model.creative.objectStorySpec.name
        ? this.model.creative.objectStorySpec.name
        : this.link
    },
    link() {
      try {
        const url = new URL(this.model.creative.objectStorySpec.link)
        return url.hostname
      } catch (Error) {
        //
      }

      return ""
    },
    page() {
      const page = this.findPage(this.model.creative.objectStorySpec.pageId)

      return page ? page : { name: "", picture: { data: { url: null } } }
    },
  },
  beforeMount() {
    this.loadPages()
  },
  beforeCreate() {
    const storeNamespace = this.$options.propsData.storeNamespace

    if (!this.$options.computed) {
      this.$options.computed = {}
    }

    if (!this.$options.methods) {
      this.$options.methods = {}
    }

    Object.assign(this.$options.computed, {
      ...get(storeNamespace, ["model"]),
    })

    Object.assign(this.$options.computed, {
      ...get("pages", ["findPage"]),
      ...get("enumerations", ["findAdsCallToActionType"]),
    })

    Object.assign(this.$options.methods, {
      ...call("pages", ["loadPages"]),
    })
  },
}
</script>

<style scoped>
.fb-ad {
  font-family: Helvetica;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
}

.fb-ad__header {
  padding: 16px;
  display: flex;
}

.fb-ad__profile-img {
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  object-fit: cover;
  border-radius: 50%;
  background: gray;
  background-size: cover;
  margin-right: 8px;
}

.fb-ad__profile-name {
  color: #506daa;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 17px;
  margin-bottom: 4px;
}

.fb-ad__time-location {
  color: #91949c;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 14px;
  display: flex;
  align-items: center;
}

.fb-ad__time-location svg {
  flex-shrink: 0;
  margin-left: 4px;
}

.fb-ad__more {
  margin-left: auto;
  padding-left: 16px;
}

.fb-ad__post {
  margin: 0 16px 14px;
  color: #000000;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 18px;
}

.fb-ad__link-web {
  border: 1px solid #dedede;
  border-left-width: 0;
  border-right-width: 0;
  background-color: #f0f2f5;
}

.fb-ad__link-image {
  width: 100%;
  padding-bottom: 100%;
  background: gray;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.fb-ad__link-body {
  margin: 15px 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.fb-ad__link-website {
  color: #91949d;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 13px;
  margin-bottom: 7px;
  text-transform: uppercase;
}

.fb-ad__link-title {
  color: #000000;

  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 22px;
  margin-bottom: 7px;
}

.fb-ad__link-subtitle {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  letter-spacing: 0;
  line-height: 14px;
}

.fb-ad__cta {
  border-radius: 5px;
  border: 1px solid #000;
  cursor: default;
  /*background-color: #e4e6ec;*/
  text-decoration: none;
  padding: 10px 12px;
  color: #000;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0;
  line-height: 14px;
  text-transform: uppercase;
}

.fb-ad__actions {
  padding: 12px 16px;
  display: flex;
  justify-content: space-around;
}

.fb-ad__action {
  color: #616770;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 16px;
  display: flex;
  align-items: center;
}

.fb-ad__action svg {
  position: relative;
  top: -1px;
  margin-right: 4px;
}
</style>
